import React from 'react';
import { formatMonetaryAmount } from 'utils/formatMonetaryAmount';
import { AdditionalFundsData } from 'handlers/applicationData';

import { ReactComponent as PlusIcon } from 'images/plus-soft-corner-icon.svg';
import { ReactComponent as ArrowDownIcon } from 'images/blue-arrow-down-icon.svg';
import { ReactComponent as CheckIcon } from 'images/check-icon.svg';

import styles from './AdditionalFunds.module.scss';

export const listIconItems = [
  {
    icon: <PlusIcon />,
    iconContainer: styles.coverExpensesIcon,
    title: 'Cover expenses',
  },
  {
    icon: <ArrowDownIcon />,
    iconContainer: styles.payOffIcon,
    title: 'Pay off more debt',
  },
  {
    icon: <CheckIcon />,
    iconContainer: styles.saveIcon,
    title: 'Save for an emergency',
  },
];

export const LARGE_LOAN_RANGE_THRESHOLD = 6000;
export const LARGE_LOAN_STEP_SIZE = 1000;
export const SMALL_LOAN_STEP_SIZE = 500;
export const MIN_SLIDER_VALUE = 0;
export const MIN_SLIDER_DISPLAY_THRESHOLD = 1000;
export const MIN_ADDITIONAL_FUNDS_THRESHOLD = 500;

export const getAdditionalFundsTitle = (
  additionalFundsRequired: boolean,
  sliderShown: boolean,
  maxSliderValue: number,
) => {
  const baseText = sliderShown
    ? 'Borrow extra funds'
    : `Borrow ${formatMonetaryAmount(maxSliderValue)} in additional funds`;

  return additionalFundsRequired ? baseText : `${baseText}?`;
};

export const getAdditionalFundsSubtitle = (
  additionalFundsRequired: boolean,
  sliderShown: boolean,
  minSliderValue: number,
) => {
  if (additionalFundsRequired) {
    return `You need to borrow ${formatMonetaryAmount(minSliderValue)} to reach the minimum loan amount.`;
  }

  if (sliderShown) return 'Optional.';

  return 'You can choose to add additional funds to your plan';
};

type GetSliderInitialValueParams = {
  additionalFundsAmount: number;
  minSliderValue: number;
  maxSliderValue: number;
};

export const getSliderInitialValue = ({
  additionalFundsAmount,
  maxSliderValue,
  minSliderValue,
}: GetSliderInitialValueParams) => {
  if (typeof additionalFundsAmount !== 'number') return minSliderValue;

  if (additionalFundsAmount <= maxSliderValue && additionalFundsAmount >= minSliderValue) {
    return additionalFundsAmount;
  }

  return minSliderValue;
};

export const meetsAdditionalFundsThreshold = (additionalFundsData: AdditionalFundsData) => {
  const { isEligible, maxAmount } = additionalFundsData;
  if (!isEligible || (isEligible && maxAmount && maxAmount < MIN_ADDITIONAL_FUNDS_THRESHOLD)) {
    return false;
  }

  return true;
};
